export default __webpack_public_path__ + "static/media/49w.91716557.svg";